<template>
    <div id='NavLink' class='ModuleNavLink col-4' :class="[ { 'active': name == currNav } ]" @click='clickOut'>
        <span>{{ formattedName }}</span>
    </div>
</template>
<script>
    export default {
        name: 'ModuleNavLink',
        props: [ 'name', 'linktype', 'displayName', 'activeModule' ],
        computed: {
            currNav(){
                return this.$route.meta.activeSubModule;
                //return this.$store.getters[this.formattedLink + '/activePageType'].type
            },
            formattedName(){
                return this.name.replace(/([A-Z])/g, ' $1').trim();
            },
        },
        methods: {
            clickOut(e){
                if(this.$props.linktype != this.$route.path) this.$router.push(this.$props.linktype);
            }
        },
    }
</script>